export default function pushDataLayer({ event, ...attrs }) {
  if (window.dataLayer) {
    window.dataLayer.push({ event, ...attrs });
  }
}
